import { render, staticRenderFns } from "./navpic.vue?vue&type=template&id=89519572&scoped=true&"
import script from "./navpic.vue?vue&type=script&lang=js&"
export * from "./navpic.vue?vue&type=script&lang=js&"
import style0 from "./navpic.vue?vue&type=style&index=0&id=89519572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89519572",
  null
  
)

export default component.exports